import React, { useState, useEffect } from 'react';
import { Tabs } from 'antd';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import EmployeeProfile from './employee-profile/EmployeeProfile';
import SalaryDetails from './employee-profile/SalaryDetails';
import EmployeAssets from './employee-profile/layout/assets-details/EmployeAssets';
import Documents from './employee-profile/layout/documents/Documents';
import EmployeeJourney from './employee-profile/layout/employee-journey/EmployeeJourney';
import EmployeeAppraisalContainer from './employee-profile/layout/Appraisal/EmployeeAppraisalContainer';
import ResginationDetails from './employee-profile/layout/deprovision/ResginationDetails';
import PerformanceNotes from './employee-profile/layout/performance-notes/PerformanceNotes';
import Loader from '../../../components/Loader/Loader';
import { toggleEmployeeTable } from '../../../redux/employeetable/employeeTableAction';
import { filterNavigationItems } from '../../../common/permissionController';

const { TabPane } = Tabs;

export default function Employee() {
  const { search } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const rolePermissions = useSelector((state: any) => state?.rolePermissions?.rolePermissions);
  const roleName = useSelector((state: any) => state?.loginUserData?.userData?.data?.role?.name);
  const resignationTabsLoad = useSelector((state: any) => state?.profileReload?.deprovisionLoad);
  const appraisalPage = useSelector((state: any) => state?.profileReload?.appraisalPageNavigate);

  const employeeName: string | null = new URLSearchParams(search).get("employeeName");

  const [loading, setLoading] = useState(true);
  const [activeTabKey, setActiveTabKey] = useState('1');
  const [employeeTab, setEmployeeTab] = useState<any>([]);
  const [layout, setLayout] = useState("profile");

  const items = [
    { key: '3', label: 'Assets', children: <EmployeAssets />, permission: 'Assets' },
    { key: '1', label: 'Salary Details', children: <SalaryDetails setDisableTabs={() => { }} />, permission: 'Salary Particulars' },
    { key: '2', label: 'Documents', children: <Documents />, permission: 'Documents' },
    { key: '4', label: 'Employee Journey', children: <EmployeeJourney />, permission: '' },
    { key: '5', label: 'Appraisal', children: <EmployeeAppraisalContainer activeTabKey={activeTabKey} />, permission: 'Review Form' },
  ];

  useEffect(() => {
    setLoading(true);


    const filteredNavigationItems = filterNavigationItems(items, rolePermissions);
    setEmployeeTab(filteredNavigationItems);


    setActiveTabKey('1');


    let finalTab = '1';
    const lastIndex = filteredNavigationItems.length - 1;
    const appraisalIndex = filteredNavigationItems.findIndex((item: any) => item?.label === 'Appraisal');

    if (resignationTabsLoad) {
      finalTab = '6';
    } else if (appraisalPage) {
      finalTab = filteredNavigationItems[appraisalIndex]?.key ?? '1';
    } else {
      finalTab = filteredNavigationItems[0]?.key ?? '1';
    }

    const timer = setTimeout(() => {
      setActiveTabKey(finalTab);
      setLoading(false);
    }, 4000);

    return () => clearTimeout(timer);
  }, [resignationTabsLoad, appraisalPage, rolePermissions]);

  const handleTabChange = (key: string) => setActiveTabKey(key);
  const layoutFull = (el: string) => setLayout(el);



  return (
    <div className='page-container bg-customBg employee_info'>
      {employeeTab?.length > 0 && (
        <div className='full-width-container'>
          <div className='employee grid grid-cols-12 gap-4'>
            {layout === "profile" && (
              <div className="employee__personal md:col-span-5 xl:col-span-4 2xl:col-span-3 col-span-12">
                <EmployeeProfile layoutFull={layoutFull} />
              </div>
            )}

            <div className={`${layout === "profile" ? "employee__details md:col-span-7 xl:col-span-8 2xl:col-span-9 col-span-12" : "employee__details md:col-span-12 col-span-12"}`}>
              <div className='bg-white tab-container employee employee-h relative !min-h-[95vh]'>

                {layout === "" && (
                  <button className="personal-card-button flex justify-center items-center" onClick={() => layoutFull("profile")}>
                    <span className='material-symbols-outlined'>chevron_right</span>
                  </button>
                )}

                <div className="bredcum-container">
                  <ul className="breadcrumb breadcrumb--classic breadCrumbsStyle pt-[7px]">
                    <li onClick={() => { dispatch(toggleEmployeeTable(false)); navigate(`/home/dashboard`) }}>Dashboard</li>
                    <li onClick={() => { dispatch(toggleEmployeeTable(true)); navigate(`/home/dashboard`) }}>Employee</li>
                    <li onClick={() => setActiveTabKey('1')} className={activeTabKey === '1' ? 'active' : ''}>{employeeName}</li>
                  </ul>
                </div>

                <Tabs activeKey={activeTabKey} onChange={handleTabChange}>
                  <TabPane key="3" tab="Assets">{activeTabKey === "3" && <EmployeAssets />}</TabPane>
                  <TabPane key="1" tab="Salary Details">{activeTabKey === "1" && <SalaryDetails setDisableTabs={() => { }} />}</TabPane>
                  <TabPane key="2" tab="Documents">{activeTabKey === "2" && <Documents />}</TabPane>
                  <TabPane key="4" tab="Employee Journey">{activeTabKey === "4" && <EmployeeJourney />}</TabPane>
                  <TabPane key="5" tab="Appraisal">{activeTabKey === "5" && <EmployeeAppraisalContainer activeTabKey={activeTabKey} />}</TabPane>

                  {resignationTabsLoad && (
                    <TabPane key="6" tab="Resignation details">{activeTabKey === "6" && <ResginationDetails activeTabKey={activeTabKey} />}</TabPane>
                  )}

                  {roleName !== "employee" && (
                    <TabPane key="7" tab="Performance Notes">{activeTabKey === "7" && <PerformanceNotes currentUserId={id ?? ''} />}</TabPane>
                  )}
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      )}
      {loading && (<div className="flex items-center justify-center w-full h-screen bg-customBg">
        <Loader />
      </div>)}
    </div>
  );
}
